<template>
  <v-container
  fluid
  class="grey lighten-5"
  >
    <v-layout column>
      <v-flex>
        <CardsLine
          header="cbot-1701"
          :data="bySource('cbot-1701')"
        />
      </v-flex>
      <v-flex>
        <CardsLine
          header="HackerNews"
          :data="bySource('hn')"
        />
      </v-flex>
      <v-flex>
        <CardsLine
          header="Lobsters"
          :data="bySource('lobsters')"
        />
      </v-flex>
      <v-flex>
        <CardsLine
          header="CBC"
          :data="bySource('cbc')"
        />
      </v-flex>
      <v-flex>
        <CardsLine
          header="BBC"
          :data="bySource('bbc')"
        />
      </v-flex>
      <v-flex>
        <CardsLine
          header="ZeroHedge"
          :data="bySource('zh')"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
import CardsLine from '../components/CardsLine';

export default {
  name: 'Feeds',
  components: {
    CardsLine
  },
  computed: {
    bySource () {
      return src => {
        var ret = this.$store.state.included.filter(item => item.attributes.source === src)
        return ret
      }
    },
  },
  // data: () => ({
  //   results: []
  // }),
};
</script>


<style scoped>
</style>
